// extracted by mini-css-extract-plugin
module.exports = {"menu":"ZhrNFnlFK0tNU4R8Kk7vr","divider-menu":"_3elWlUJAwU9Zpplew37Of_","active":"_1rivyKj_Uu3S4GnUrJBIU7","content":"w8PcBWSQh1qfmqsWxwL33"};